import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <Compass className="h-10 w-10 text-ink-faint" aria-hidden="true" />
      <h1 className="text-lg font-semibold text-ink">Pagina no encontrada</h1>
      <p className="max-w-sm text-sm text-ink-muted">
        La seccion que buscas no existe o se ha movido.
      </p>
      <Link
        to="/"
        className="mt-2 inline-flex h-10 items-center justify-center rounded-lg bg-brand-700 px-4 text-sm font-medium text-white transition-colors hover:bg-brand-800 focus-visible:outline-brand-700"
      >
        Volver al dashboard
      </Link>
    </div>
  );
}
